import { useQuery } from '@tanstack/react-query';

import { useApplicationContext } from '~/shared/context/use-application-context';
import { activeAnnouncementsResponseSchema } from '~/shared/data-contract/announcements';

import { announcementKeys } from './query-keys';

export const useActiveAnnouncement = () => {
    const { validatingCobrainerApiFetcher } = useApplicationContext();

    return useQuery({
        queryFn: async () => {
            const result = await validatingCobrainerApiFetcher.get(activeAnnouncementsResponseSchema, {
                pathname: '/announcements/active',
            });

            if (result.isOk) {
                return result.value;
            }

            throw result.error;
        },
        queryKey: announcementKeys.active(),
        refetchOnWindowFocus: false,
        retry: false,
        staleTime: 5 * 60 * 1000,
        throwOnError: false,
    });
};
